
import { FSXABaseComponent } from 'fsxa-pattern-library'
import { Component, Prop } from 'nuxt-property-decorator'
import PageHeader from './PageHeader.vue'
import PageOverlays from './PageOverlays.vue'
import PageFooter from './PageFooter.vue'
import PageContent from './PageContent.vue'

@Component({
  name: 'Page',
  components: {
    PageHeader,
    PageContent,
    PageOverlays,
    PageFooter,
  },
})
export default class Page extends FSXABaseComponent {
  @Prop() headerHeight ?: number
}
